import {DtoTechnologyRequestInterface, DtoTechnologyResponseInterface, TechnologyModel} from "../interfaces";
import {mapTechnologyTranslationFromDtoArray, mapTechnologyTranslationToDtoArray} from "./technology-translation.mapping";

export const mapTechnologyFromDto = (dto: DtoTechnologyResponseInterface): TechnologyModel => {
  let canNotBeDeleted = false;
  if ((dto.assetTypeCount && dto.assetTypeCount > 0) || (dto.assetTypeCount && dto.assetTypeCount > 0)) {
    canNotBeDeleted = true;
  }

  return {
    name: dto.name,
    businessArea: dto.businessArea,
    id: dto.id,
    assetTypeCount: dto.assetTypeCount ?? 0,
    assetCount: dto.assetCount ?? 0,
    translations: mapTechnologyTranslationFromDtoArray(dto.translations ?? []),
    translationsCount: dto.translations?.length ?? 0,
    canNotBeDeleted: canNotBeDeleted,
    isAccessory: dto.isAccessory ?? false
  };
};

export const mapTechnologyFromDtoArray = (array: Array<DtoTechnologyResponseInterface>): Array<TechnologyModel> => {
  const result: Array<TechnologyModel> = [];

  array.forEach(dto => {
    result.push(mapTechnologyFromDto(dto));
  });

  return result;
};

export const mapTechnologyToDto = (model: TechnologyModel): DtoTechnologyRequestInterface => {
  return {
    name: model.name,
    businessArea: model.businessArea,
    translations: mapTechnologyTranslationToDtoArray(model.translations),
    isAccessory: model.isAccessory ?? false
  };
};
